import { invariant } from './invariant.util';
import { isDefined } from './is-defined.util';

export const ensureDefined = <T extends Record<string, unknown>>(
  input: Readonly<{ [K in keyof T]: T[K] | null | undefined }>,
  errorMessage?: string,
): T => {
  invariant(!!Object.keys(input).length, 'Object must have at least one key');

  const [output, missingKeys] = Object.entries(input).reduce<[T, string[]]>(
    ([acc, missing], [key, value]) => {
      if (!isDefined(value)) {
        return [acc, [...missing, key]];
      }

      return [
        { ...acc, [key]: value as (typeof input)[Extract<keyof T, string>] },
        missing,
      ];
    },
    [{} as T, []],
  );

  invariant(
    !missingKeys.length,
    errorMessage ??
      `Values for the following keys are not defined: ${missingKeys.join(', ')}`,
  );

  return output;
};
